import service from '@/utils/request.js';

const data = {
  state: {
    questions: [],
    irrelevantQuestions: [],
    vts: [],
    tasks: [],
    surveys: [],
  },
  mutations: {
    SET_VTS: (state, vts) => {
      state.vts = vts
    },
    UPDATE_VT: (state, vt) => {
      const index = state.vts.findIndex(v => v.id === vt.id)
      state.vts.splice(index, 1, vt)
    },
    SET_QUESTIONS: (state, questions) => {
      state.questions = questions
    },
    SET_IRRELEVANT_QUESTIONS: (state, questions) => {
      state.irrelevantQuestions = questions
    },
    UPDATE_QUESTION: (state, question) => {
      const index = state.questions.findIndex(q => q.id === question.id)
      state.questions.splice(index, 1, question)
    },
    UPDATE_IRRELEVANT_QUESTION: (state, question) => {
      const index = state.irrelevantQuestions.findIndex(q => q.id === question.id)
      state.irrelevantQuestions.splice(index, 1, question)
    },
    SET_TASKS: (state, tasks) => {
      state.tasks = tasks
    },
    UPDATE_TASK: (state, task) => {
      const index = state.tasks.findIndex(t => t.id === task.id)
      if (index === -1) {
        state.tasks.push(task)
      } else {
        state.tasks.splice(index, 1, task)
      }
    },
    SET_SURVEYS: (state, surveys) => {
      state.surveys = surveys
    },
    PUSH_SURVEYS: (state, survey) => {
      state.surveys.push(survey)
    },
    UPDATE_SURVEYS: (state, survey) => {
      const index = state.surveys.findIndex(t => t.id === survey.id)
      if (index === -1) {
        state.surveys.push(survey)
      } else {
        state.surveys.splice(index, 1, survey)
      }
    },
  },
  actions: {
    async fetchVTs({commit}) {
      if (state.vts.length === 0) { // only fetch if not already fetched
        const response = await service.get(`todos/v1/vts/${this.state.account.accountid}/`)
        commit('SET_VTS', response.data)
      }
    },
    async fetchQuestions({commit}) {
      if (state.questions.length === 0) { // only fetch if not already fetched
        const response = await service.get(`todos/v1/questions/${this.state.account.accountid}/`)
        commit('SET_QUESTIONS', response.data)
      }
    },
    async fetchIrrelevantQuestions({commit}) {
      if (state.irrelevantQuestions.length === 0) { // only fetch if not already fetched
        const response = await service.get(`todos/v1/irrelevant_questions/${this.state.account.accountid}/`)
        commit('SET_IRRELEVANT_QUESTIONS', response.data)
      }
    },
    async fetchTasks({commit}) {
      if (state.tasks.length === 0) { // only fetch if not already fetched
        const response = await service.get(`todos/v1/tasks/${this.state.account.accountid}/`)
        commit('SET_TASKS', response.data)
      }
    },
    async updateVT({commit}, vt) {
      commit('UPDATE_VT', vt)
    },
    async updateQuestion({commit}, question) {
      commit('UPDATE_QUESTION', question)
    },
    async updateIrrelevantQuestion({commit}, question) {
      commit('UPDATE_IRRELEVANT_QUESTION', question)
    },
    async updateTask({commit}, task) {
      commit('UPDATE_TASK', task)
    },
    async updateSurvey({commit}, survey) {
      commit('UPDATE_SURVEYS', survey)
    }
  },
  getters: {
    getQuestionById: (state) => (id) => {
      return state.questions.find(q => q.id === id)
    },
    getIrrelevantQuestionById: (state) => (id) => {
      return state.irrelevantQuestions.find(q => q.id === id)
    },
    getVTById: (state) => (id) => {
      return state.vts.find(v => v.id === id)
    },
    getTaskById: (state) => (id) => {
      return state.tasks.find(t => t.id === id)
    },
    getQuestions: (state) => {
      return state.questions
    },
    getIrrelevantQuestions: (state) => {
      return state.irrelevantQuestions
    },
    getVTs: (state) => {
      return state.vts
    },
    getTasks: (state) => {
      return state.tasks
    },
    getSurveys: (state) => {
      return state.surveys
    },
    getSurveyById: (state) => (id) => {
      return state.surveys.find(q => q.id === id) || {}
    },
  }
}

export default data
